import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'time_sync_status'
})
export class TimeSyncStatusPipe implements PipeTransform {

  transform(value: number): string {
    if (value === 2) {
      return 'NOK';
    }
    if (value === 0) {
      return 'OK';
    }
    if (!value) {
      return '';
    }
    return value.toString();
  }
}
